import { all, fork } from 'redux-saga/effects';
import { RootState } from '../index';
import { watchGetCurrentUserProfileSaga } from './sagas/get';
import { watchSaveCurrentUserProfileSaga } from './sagas/save';
import { slice } from './slice';

export function* currentUserProfileRootSaga(): Generator {
  yield all([
    fork(watchGetCurrentUserProfileSaga),
    fork(watchSaveCurrentUserProfileSaga),
  ]);
}

export const getCurrentUserProfileState = (state: RootState) =>
  state.currentUserProfile;

export const { start, success } = slice.actions;
export const currentUserProfileReducer = slice.reducer;
